import script from "./VinificationTimeline.vue?vue&type=script&setup=true&lang=js"
export * from "./VinificationTimeline.vue?vue&type=script&setup=true&lang=js"

import "./VinificationTimeline.vue?vue&type=style&index=0&id=9ef41c58&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9ef41c58"]])

export default __exports__